import { AppInterface } from "@swivl-mono/types";
import { Input, Spinner } from "@swivl-mono/ui";

import AppsModel from "../../../../Models/Apps/Apps.Model";
import { Field } from "../AppInstanceField";

interface Props {
  app: AppInterface;
  selected?: boolean;
  /** When false, fields are read-only and edits are staged until Save. */
  disabled?: boolean;
}
export default function MandrilAppView({ app, disabled }: Props) {
  let content;

  function onChange(e) {
    var mandrill = app;

    const name = e.target.name;
    const value = e.target.value;
    if (name === "mandrill_api_key") {
      var token = mandrill.token || {};
      token.mandrill_api_key = value;
      mandrill.token = token;
    } else {
      var data = mandrill.data || {};
      data[name] = value;
      mandrill.data = data;
    }
    AppsModel.update(mandrill, false);
  }

  function onBlur(e) {
    AppsModel.update(app, false);
  }

  if (!app) {
    content = <Spinner />;
  } else {
    let mandrill_from_name = app.data.mandrill_from_name || "";
    let mandrill_from_email = app.data.mandrill_from_email || "";
    let mandrill_api_key = app.token.mandrill_api_key || "";

    content = (
      <div className="mandrillValues flex flex-col gap-1">
        <Field label="From Name" disabled={disabled} value={mandrill_from_name}>
          <Input name="mandrill_from_name" value={mandrill_from_name} onChange={onChange} onBlur={onBlur} />
        </Field>
        <Field label="From Email Address" disabled={disabled} value={mandrill_from_email}>
          <Input name="mandrill_from_email" value={mandrill_from_email} onChange={onChange} onBlur={onBlur} />
        </Field>
        <Field label="Mandrill API Key" disabled={disabled} value={mandrill_api_key ? "••••••••" : ""}>
          <Input name="mandrill_api_key" value={mandrill_api_key} onChange={onChange} onBlur={onBlur} type="password" />
        </Field>
      </div>
    );
  }

  return <div className="MandrillView">{content}</div>;
}
